export const createNamespace = (namespace: string) => {
  return `@chat/${namespace}`;
};
